import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=7d7b4c65&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\xampp\\htdocs\\app.poojalab.com\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d7b4c65')) {
      api.createRecord('7d7b4c65', component.options)
    } else {
      api.reload('7d7b4c65', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=7d7b4c65&", function () {
      api.rerender('7d7b4c65', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/task/edit.vue"
export default component.exports